import styled from 'styled-components';

import { ThemeProp } from '../../../../../../../theme/Themes';

const IMAGE_WIDTH = '4rem';
const VEHICLE_INFORMATION_CONTAINER_GAP = '0.75rem';

interface VehicleInformationContainerProps {
  $isInitialStep: boolean;
}

export const VehicleInformationContainer = styled.div<VehicleInformationContainerProps>`
  display: flex;
  align-items: center;
  gap: ${VEHICLE_INFORMATION_CONTAINER_GAP};
  width: 100%;

  ${(props) => !props.$isInitialStep && 'padding: 0.5rem;'};
  ${(props) => !props.$isInitialStep && 'border-radius: 0.5rem;'};
  ${(props) => !props.$isInitialStep && `border: 1px solid ${props.theme.colors.main.c100};`};
  ${(props) => !props.$isInitialStep && `background: ${props.theme.colors.main.c050};`};
`;

export const VehicleImage = styled.img`
  width: ${IMAGE_WIDTH};
  height: 3.125rem;
  border-radius: 0.25rem;
  object-fit: cover;
`;

export const VehicleDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  width: ${`calc(100% - ${IMAGE_WIDTH} - ${VEHICLE_INFORMATION_CONTAINER_GAP})`};
`;

export const Title = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.ml};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.ml};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  color: ${(props: ThemeProp) => props.theme.colors.white};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Subtitle = styled(Title)`
  color: ${(props: ThemeProp) => props.theme.colors.content.subdued.low};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
`;
